// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"166":"quiz","535":"login"}[chunkId] + "." + {"166":"dde090ff","535":"7234d399"}[chunkId] + ".css";
};